import { render, staticRenderFns } from "./build3.vue?vue&type=template&id=3245ed85&scoped=true&"
import script from "./build3.vue?vue&type=script&lang=js&"
export * from "./build3.vue?vue&type=script&lang=js&"
import style0 from "./build3.vue?vue&type=style&index=0&id=3245ed85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245ed85",
  null
  
)

export default component.exports